import React, { memo, useCallback, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Popover } from '@lyearn/ui';
import NumberInput from '@/components/NumberInput';

import { NumberValue } from '../../types';
import ActionButton from './ActionButton';
import { inputStyle } from './styles';
import { TagsValueSelectorProps } from './types';

function NumberSelect(props: TagsValueSelectorProps) {
  const { t } = useTranslation();
  const { className, tag, selectedTagValue, onChange, onDelete, error, readOnly, children } = props;
  const numberTagValue = (selectedTagValue || '') as NumberValue;
  const [inputVal, setInputVal] = useState(numberTagValue);
  const onInputChange = useCallback(
    (val: NumberValue) => {
      onChange(val);
    },
    [onChange],
  );

  const onBlur = useCallback(() => {
    onInputChange(inputVal);
  }, [onInputChange, inputVal]);

  return (
    <Box className={cn('max-w-full relative', className)}>
      <Popover>
        <Popover.Button>
          {children || (
            <ActionButton
              className={className}
              defaultPlaceholder={t('Tags:Form.TypeValue')}
              error={error}
              readOnly={readOnly}
              selectedTagValue={numberTagValue?.toString()}
              tag={tag}
              onDelete={onDelete}
            />
          )}
        </Popover.Button>
        <Popover.Content position="bottom-start">
          <NumberInput
            autoFocus
            canBeEmpty
            className={cn('body-short-02 h-48 w-full bg-bg-primary', inputStyle)}
            min={0}
            placeholder={t('Tags:Form.AddANumber')}
            value={inputVal!}
            onBlur={onBlur}
            onChange={setInputVal}
            onEnter={onBlur}
          />
        </Popover.Content>
      </Popover>
    </Box>
  );
}

export default memo(NumberSelect);
